import { meta } from '../meta';
import type { WidgetPageType } from '../types';

export const WIDGET_CLASS = `eapps-${meta.appAlias}`;
export const DEFAULT_PAGE: WidgetPageType = 'main';

export const TEXT_TAGS = [
  'div',
  'span',
  'a',
  'p',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'strong',
  'em',
  'b',
  'i',
  'u',
  'mark',
  'small',
  'del',
  'ins',
  'sub',
  'sup',
  'code',
  'pre',
  'blockquote',
  'q',
  'abbr',
  'cite',
  'dfn',
  'kbd',
  'var',
  'address',
  'time',
  's',
  'wbr',
  'button'
];
